module.exports = __webpack_public_path__ + "static/media/3 02 Tulleord Sgo.cd86a38d.mp3";